export default __webpack_public_path__ + "static/media/product.2be86f47.svg";